const getUsersFullName = userObj => {
  if (!userObj || !userObj.profile) {
    return 'unkown';
  }
  if (!userObj.profile.firstName && !userObj.profile.lastName) {
    return 'unkown';
  }
  if (userObj.profile.firstName && userObj.profile.lastName) {
    return `${userObj.profile.firstName}  ${userObj.profile.lastName}`;
  }
  if (userObj.profile.firstName && !userObj.profile.lastName) {
    return `${userObj.profile.firstName}`;
  }
  return null;
};

export default getUsersFullName;



// WEBPACK FOOTER //
// ./src/lib/helpers/GeneralHelpers/getUsersFullName.js